export const font = {
  openSans: '"Open Sans", sans-serif'
};

export const theme = {
  primaryColor: '#278C7E',
  textColor: {
    white: '#ffffff'
  },
  textSize: {
    regular: '12',
    small: '10',
    xsmall: '9'
  },
  fontWeight: {
    normal: 'normal',
    bold: 'bold'
  },
  backgroundColor: 'rgba(79, 94, 163, 0.49)'
};
